<template>
  <div
    v-show="isContentLoaded"
    v-click-outside="closeMenu"
    class="menu-alert"
  >
    <div
      v-if="!isLightGreyPlan"
      class="alert-icon ic-checkin"
      @click="handleClickCheckin"
    />

    <div
      class="alert-icon ic-alert"
      :class="{'has-alert': hasUnreadMessage}"
      @click="handleClickAlertIcon"
    />

    <transition name="el-zoom-in-top">
      <div
        v-show="isPopupVisible"
        class="menu-alert__detail-popup top-menu__popup"
      >
        <h3>
          알림
        </h3>

        <warning-message
          v-if="alerts.length === 0"
          message="등록된 알림이 없습니다."
        />
        <div
          v-else
          class="alert-item-container"
        >
          <router-link
            v-for="(alert, index) in alerts"
            :key="index"
            class="alert-item"
            :to="'/fiflbox-notices/' + alert.id"
            :class="{'unread': !alert.is_opened}"
          >
            <div class="alert-item__user-thumbnail" />
            <span class="alert-item__message">
              {{ alert.title }}
            </span>
            <span class="alert-item__date">
              {{ presentDate(alert.published) }}
            </span>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { format } from "date-fns";
import { computedGetters } from "../../utils/vuex-helper";
import vClickOutside from "v-click-outside";
import WarningMessage from "../../components/element-ui/WarningMessage";

export default {
	name: "MenuAlert",
	components: { WarningMessage },
	directives: {
		clickOutside: vClickOutside.directive,
	},
	data() {
		return {
			isPopupVisible: false,
			isContentLoaded: false,
		};
	},
	computed: {
		...computedGetters(["alerts"]),
		hasUnreadMessage() {
			return this.alerts ? this.alerts.filter(alert => !alert.is_opened).length > 0 : false;
		},
		isLightGreyPlan() {
			return this.$store.getters.getIsLightGreyPlan;
		},
	},
	watch: {
		$route() {
			this.isPopupVisible = false;
		},
	},
	async created() {
		await this.$store.dispatch("syncAlerts");
		this.isContentLoaded = true;
	},
	methods: {
		presentDate(date) {
			return format(date, "YY.MM.DD");
		},
		handleClickCheckin() {
			window.open("/#/checkin", "_blank");
		},
		handleClickAlertIcon() {
			this.isPopupVisible = true;
		},
		closeMenu() {
			this.isPopupVisible = false;
		},
	},
};
</script>

<style lang="scss">
.menu-alert {
	display: flex;
	height: 100%;
	align-items: center;
	margin-right: 13px;
	position: relative;

	.menu-alert__detail-popup {
		z-index: 99999;

		position: absolute;
		top: 60px;
		right: 0;
		width: 360px;
		height: 320px;

		h3 {
			height: 50px;
			line-height: 50px;
			font-family: NotoSansCJKkr;
			font-size: 14px;
			font-weight: bold;
			letter-spacing: -0.8px;
			color: #4a4a4a;
			padding: 0 20px;
			box-sizing: border-box;
			margin: 0;
		}

		.warning-message-container {
			margin-top: 60px;
		}

		.alert-item-container {
			height: 270px;
			overflow-y: auto;
		}

		.alert-item {
			height: 60px;
			padding: 10px 20px;
			display: flex;
			justify-content: center;
			align-content: center;
			align-self: center;
			border-top: 1px solid #f2f2f2;
			box-sizing: border-box;
			text-decoration: none;

			&.unread {
				font-weight: bold;
			}

			&:hover {
				cursor: pointer;
				background-color: #f9f9f9;
			}

			&:last-child {
				border-bottom: 1px solid #f2f2f2;
			}

			.alert-item__user-thumbnail {
				margin-right: 10px;
				min-width: 40px;
				width: 40px;
				height: 40px;
				border-radius: 40px;
				background-color: #f2f2f2;
				display: inline-block;
				flex: initial;
				background-image: url("//cdn.fiflbox.com/admin/fifl_circle.png");
				background-repeat: no-repeat;
				background-size: cover;
			}

			.alert-item__message {
				font-size: 14px;
				letter-spacing: -0.8px;
				color: #4a4a4a;
				flex: auto;
				line-height: 40px;

				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;

				margin-right: 10px;
			}

			.alert-item__date {
				color: #9b9b9b;
				width: 50px;
				font-size: 14px;
				letter-spacing: -0.8px;
				flex: initial;
				line-height: 40px;
				font-weight: normal;
			}
		}
	}

	@media screen and (max-width: 768px) {
		position: initial;

		.menu-alert__detail-popup {
			width: calc(100vw - 30px);
			right: 15px;
			position: absolute;
		}
	}
}

.alert-icon {
	width: 35px;
	height: 35px;
	cursor: pointer;

	&.has-alert {
		position: relative;

		&::before {
			content: "";
			position: absolute;
			top: 0;
			right: 0;
			width: 8px;
			height: 8px;
			background-color: #4a4a4a;
			border-radius: 8px;
		}
	}

	& + .alert-icon {
		margin-left: 10px;
	}
}
</style>
